// extracted by mini-css-extract-plugin
export default {"title":"Links_title__raGXe","title-update-container":"Links_title-update-container__E7zbD"};